import React, { ReactElement, useRef, useState } from 'react';

import useScript from '../../hooks/useScript';
import { TrustpilotReviewsWrapper } from './TrustpilotReviewsWidget.styled';

import { StyledComponentProps } from '../../types/style';

interface TrustpilotReviewsWidgetProps extends StyledComponentProps {
  inView?: boolean;
}

export function TrustpilotReviewsWidget({
  inView = true,
  className,
}: TrustpilotReviewsWidgetProps): ReactElement {
  const trustpilotRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  useScript(
    'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
    inView,
    () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(trustpilotRef.current, true);

        setIsLoading(false);
      }
    }
  );

  return (
    <TrustpilotReviewsWrapper
      className={className || 'trustpilot-widget'}
      data-locale="en-GB"
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="645a25aacca19f30ea5a359e"
      data-style-height="24px"
      data-style-width="100%"
      data-theme="light"
      isLoading={isLoading}
      ref={trustpilotRef}
    >
      <a
        href="https://uk.trustpilot.com/review/togather.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </TrustpilotReviewsWrapper>
  );
}
